import React from "react";
import { FaFileDownload } from "react-icons/fa";
import styles from "./CalibrationRequestForm.module.scss";

const CalibrationRequestRecap = ({
  t,
  formData,
  selectedCabine,
  isBone,
  isPostalCalibration,
  isEars,
  isEarsReceive,
  isArtificialEarShipment,
  shouldProvideUserPdf,
  loading,
  error,
  onDownloadPdf,
  onConfirmSend,
}) => (
  <div className={styles.recapSection}>
    <div className={styles.recapLayout}>
      {isPostalCalibration && (
        <div className={styles.topBanner}>
          <div className={styles.postalInfo}>
            <h4>{t("calibration_request.postal_title")}</h4>
            <p>{t("calibration_request.postal_instructions")}</p>
            <address className={styles.address}>
              {t("calibration_request.postal_address")}
            </address>
            <p className={styles.postalNote}>
              {t("calibration_request.postal_note")}
            </p>
          </div>
          {isBone && (
            <div className={styles.warningBox}>
              {t("calibration_request.bone_warning")}
            </div>
          )}
        </div>
      )}

      {(isEars || isArtificialEarShipment) && (
        <div className={styles.topBanner}>
          <div className={styles.postalInfo}>
            <h4>{t("calibration_request.tnt_title")}</h4>
            <p>
              {isEarsReceive || isArtificialEarShipment
                ? t("calibration_request.tnt_instructions_receive")
                : t("calibration_request.tnt_instructions_return")}
            </p>
          </div>
        </div>
      )}

      <div className={styles.recapMain}>
        <div className={styles.recapCard}>
          <h4 className={styles.recapTitle}>
            {t("calibration_request.recap_title")}
          </h4>
          <dl className={styles.recapList}>
            <dt>{t("calibration_request.field_name")}</dt>
            <dd>{formData.name}</dd>
            <dt>{t("calibration_request.field_email")}</dt>
            <dd>{formData.email}</dd>
            {formData.phone && (
              <>
                <dt>{t("calibration_request.field_phone")}</dt>
                <dd>{formData.phone}</dd>
              </>
            )}
            <dt>{t("calibration_request.field_cabine")}</dt>
            <dd>{selectedCabine?.cabname || `Cabine ${formData.cabineId}`}</dd>
            <dt>{t("calibration_request.field_address_title")}</dt>
            <dd>
              {formData.centerName && (
                <>
                  <span>{formData.centerName}</span>
                  <br />
                </>
              )}
              <span>{formData.address}</span>
              {formData.address2 && (
                <>
                  <br />
                  <span>{formData.address2}</span>
                </>
              )}
              <br />
              <span>{[formData.zipCode, formData.city].filter(Boolean).join(" ")}</span>
              {formData.country && (
                <>
                  <br />
                  <span>{formData.country}</span>
                </>
              )}
            </dd>
            {isBone && (
              <>
                <dt>{t("calibration_request.field_serial_dragonfly")}</dt>
                <dd>
                  {formData.noDragonfly
                    ? t("calibration_request.serial_unavailable")
                    : formData.serialDragonfly}
                </dd>
                <dt>{t("calibration_request.field_serial_co")}</dt>
                <dd>
                  {formData.noCO
                    ? t("calibration_request.serial_unavailable")
                    : formData.serialCO}
                </dd>
              </>
            )}
            {formData.message && (
              <>
                <dt>{t("calibration_request.field_message")}</dt>
                <dd>{formData.message}</dd>
              </>
            )}
          </dl>
        </div>

        {shouldProvideUserPdf && (
          <button
            className={styles.downloadBtn}
            onClick={onDownloadPdf}
            disabled={loading}
            type="button"
          >
            <FaFileDownload />
            {t("calibration_request.download_coupon")}
          </button>
        )}

        {error && <p className={styles.error}>{error}</p>}

        <button
          className={styles.submitBtn}
          onClick={onConfirmSend}
          disabled={loading}
          type="button"
        >
          {loading
            ? t("calibration_request.sending")
            : t("calibration_request.confirm_send")}
        </button>
      </div>
    </div>
  </div>
);

export default CalibrationRequestRecap;
